import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

type TabPanelProps = {
    children?: React.ReactNode;
    index: any;
    value: any;
}

export default function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box paddingTop={2}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}